var Cabin = Backbone.View.extend({
  events: {
    "change [data-travelers]": "togglePassengerDetails"
  },

  togglePassengerDetails: function() {
    var total = 0;

    _.each(this.$("[data-travelers]"), function(el) {
      total += parseInt($(el).val());
    });

    if (this.$("[data-traveler-details]").length) {
      var Component = this.$("[data-traveler-details]").component();
      Component.addRemoveFields(total);
    }
  },

  initialize: function() {
    this.$el.loadComponents();
    this.$el.loadModules();
  }
});

var CruiseRequest = Backbone.View.extend({
  events: {
    "change [data-cabin-trigger]": "toggleCabins"
  },

  toggleCabins: function() {
    var cabins = this.$("[data-cabin-trigger]").val();

    if (cabins > 1) {
      this.$("[data-cabin-label]").removeClass("is-hidden");
    } else {
      this.$("[data-cabin-label]").addClass("is-hidden");
    }

    for (var x = 1; x <= 4; x++) {
      if (x <= cabins) {
        this.$('[data-cabin="' + x + '"]')
          .prop("checked", true)
          .trigger("change");
      } else {
        this.$('[data-cabin="' + x + '"]')
          .prop("checked", false)
          .trigger("change");
      }
    }
  },

  initialize: function() {
    this.$el.loadComponents();
    this.$el.loadModules();

    this.$("[data-cabin-block]").each(function() {
      new Cabin({ el: this });
    });
  }
});

module.exports = CruiseRequest;
